import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";
import Restaurant from "../../models/restaurant.ts";
import LogUtils from "../../utils/log-utils.ts";

export default class V1GroupTopRestaurants extends BaseIncomingPayload {
  public readonly payload: V1GroupTopRestaurantsPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_TOP_RESTAURANTS);

    this.payload = new V1GroupTopRestaurantsPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupTopRestaurantsPayload {
  public readonly group_id: string;
  public readonly top_restaurants: Restaurant[];

  constructor(payload: Record<string, unknown>) {
    this.group_id = ParseUtils.parseString(payload, "group_id");

    // "top_restaurants" field
    const topRestaurants: Restaurant[] | null = Restaurant.parseArrayFromPayload(payload);
    if (topRestaurants === null) {
      LogUtils.error("attempted to parse 'top_restaurants', but it came back 'null'");
    }
    this.top_restaurants = topRestaurants;
  }
}
